import axios from 'axios';

import {getHeaders} from './jilApiUtils';

let clientId, includeRoles, url;

/**
 * Configure JIL organizationsMigrations APIs
 *
 * @param {Object} config - The configuration object
 * @param {String} config.url - The root url for JIL organizations migrations api
 * @param {String} config.clientId - The identifier for application
 * @param {Array<String>} config.includeRoles - An array of admin roles to include in the request
 */
const configure = (config) => {
  ({url, clientId, includeRoles} = config);
};

/**
 * Fetches all migrations for the auth'd user or a specific org if orgId is provided
 *
 * @param {String} orgId - The org id
 * @param {String} types - Migration types for getting migration information
 * @returns {Promise} Resolves to the axios response object whose data contains an array of OrganizationsMigrations
 */
const getMigrations = async ({orgId, types}) => {
  const params = {
    types,
  };
  const headers = {
    Accept: 'application/vnd.com.adobe.jil.organizations.migrations.v2+json',
    ...getHeaders({clientId, includeRoles}),
  };

  const response = await axios.get(`${url}/v2/organizations/${orgId}/migrations`, {
    headers,
    params,
  });

  return response;
};

const jilOrganizationsMigrations = {
  configure,
  getMigrations,
};

export default jilOrganizationsMigrations;
